import { useEffect, useRef } from "react";

function ModalGlobalTopbar({ mostrar, aoFechar, children }) {
  const refModal = useRef(null);

  useEffect(() => {
    function fecharAoClicarFora(evento) {
      if (refModal.current && !refModal.current.contains(evento.target)) {
        aoFechar();
      }
    }

    if (mostrar) {
      document.addEventListener("mousedown", fecharAoClicarFora);
    }

    return () => {
      document.removeEventListener("mousedown", fecharAoClicarFora);
    };
  }, [mostrar, aoFechar]);

  if (!mostrar) return null;

  return (
    <div>
      <div ref={refModal} >
        {children}
      </div>
    </div>
  );
}

export default ModalGlobalTopbar;
